export default __webpack_public_path__ + "static/media/ic_excel.f7ad5380.png";